import { render, staticRenderFns } from "./v-input-range.vue?vue&type=template&id=ec5596a8&scoped=true&"
import script from "./v-input-range.vue?vue&type=script&lang=js&"
export * from "./v-input-range.vue?vue&type=script&lang=js&"
import style0 from "./v-input-range.vue?vue&type=style&index=0&id=ec5596a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec5596a8",
  null
  
)

export default component.exports